import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Contact } from '../../model/itsm';
import { ItsmService } from '../../services/itsm.service';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit {
  @Input()
  contacts: Contact[];

  @Input()
  flagRefs: any[];

  @Input()
  flaggingRef: string;

  @Output()
  flagEmitter = new EventEmitter<any>();

  @Output()
  sortEmitter = new EventEmitter<any>();

  @Output()
  reloadContacts = new EventEmitter<any>();

  @Input()
  loaded: boolean;
  constructor(private itsmService: ItsmService, private router: Router) { }

  //Error messaged
  notdeleted: boolean = false;
  deleted:boolean = false;
  ngOnInit(): void {
  }

  deleteContact(id: string): void{

    this.loaded=false;
    this.itsmService.deleteContact(id)
    .then(res=>{
    
      this.notdeleted = false
      this.deleted = true
      sessionStorage.removeItem("itsmContacts")
      this.reloadContacts.emit();

      this.loaded=true;
    })
    .catch(ex => {
      this.loaded=true;

      this.deleted = false
      this.notdeleted = true
      console.log("delete contact failed", ex)
    })
  }
  editUser(contact:{}):void{
    this.router.navigateByUrl('/support/contacts/addcontacts', {state:{userData:contact}})
  }

}
